import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IAddPermisosToCargoRequest, ICargosPermiso } from '../../shared/interfaces/database/seguridad';

@Injectable({
  providedIn: 'root'
})
export class SecCargoPermisoService {
  private readonly baseUrl = `${environment.apiUrl}/api/cargo-permiso`;

  constructor(private readonly http: HttpClient) { }

  getCargoPermisos(): Observable<ICargosPermiso[]> {
    return this.http.get<ICargosPermiso[]>(`${this.baseUrl}`);
  }

  addPermisosToCargo(request: IAddPermisosToCargoRequest): Observable<boolean> {
    return this.http.put<boolean>(`${this.baseUrl}`, request);
  }

  removePermisosFromCargo(cargoId: number, permisoId: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.baseUrl}/${cargoId}/${permisoId}`);
  }
}
